"use strict";
/*
  This file is part of web3x.

  web3x is free software: you can redistribute it and/or modify
  it under the terms of the GNU Lesser General Public License as published by
  the Free Software Foundation, either version 3 of the License, or
  (at your option) any later version.

  web3x is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU Lesser General Public License for more details.

  You should have received a copy of the GNU Lesser General Public License
  along with web3x.  If not, see <http://www.gnu.org/licenses/>.
*/

var _objectSpread = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var sent_contract_tx_1 = require("./sent-contract-tx");

var Tx = /*#__PURE__*/function () {
  function Tx(eth, contractEntry, contractAbi, contractAddress) {
    var args = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
    var defaultOptions = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};

    _classCallCheck(this, Tx);

    this.eth = eth;
    this.contractEntry = contractEntry;
    this.contractAbi = contractAbi;
    this.contractAddress = contractAddress;
    this.args = args;
    this.defaultOptions = defaultOptions;
  }

  _createClass(Tx, [{
    key: "estimateGas",
    value: function () {
      var _estimateGas = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var options,
            _args = arguments;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                options = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};
                _context.next = 3;
                return this.eth.estimateGas(this.getTx(options));

              case 3:
                return _context.abrupt("return", _context.sent);

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function estimateGas() {
        return _estimateGas.apply(this, arguments);
      }

      return estimateGas;
    }()
  }, {
    key: "call",
    value: function () {
      var _call = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var options,
            block,
            result,
            _args2 = arguments;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                options = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : {};
                block = _args2.length > 1 ? _args2[1] : undefined;
                _context2.next = 4;
                return this.eth.call(this.getTx(options), block);

              case 4:
                result = _context2.sent;
                return _context2.abrupt("return", this.contractEntry.decodeReturnValue(result));

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function call() {
        return _call.apply(this, arguments);
      }

      return call;
    }()
  }, {
    key: "getCallRequestPayload",
    value: function getCallRequestPayload(options, block) {
      var _this = this;

      var result = this.eth.request.call(this.getTx(options), block);
      return _objectSpread({}, result, {
        format: function format(result) {
          return _this.contractEntry.decodeReturnValue(result);
        }
      });
    }
  }, {
    key: "send",
    value: function send(options) {
      var tx = this.getTx(options);

      if (!this.contractEntry.payable && tx.value !== undefined && tx.value > 0) {
        throw new Error('Can not send value to non-payable contract method.');
      }

      var promise = this.eth.sendTransaction(tx).getTxHash();
      return new sent_contract_tx_1.SentContractTx(this.eth, this.contractAbi, promise);
    }
  }, {
    key: "getSendRequestPayload",
    value: function getSendRequestPayload(options) {
      return this.eth.request.sendTransaction(this.getTx(options));
    }
  }, {
    key: "encodeABI",
    value: function encodeABI() {
      return this.contractEntry.encodeABI(this.args);
    }
  }, {
    key: "getTx",
    value: function getTx() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return {
        to: this.contractAddress,
        from: options.from || this.defaultOptions.from,
        gasPrice: options.gasPrice || this.defaultOptions.gasPrice,
        gas: options.gas || this.defaultOptions.gas,
        value: options.value,
        data: this.encodeABI(),
        nonce: options.nonce
      };
    }
  }]);

  return Tx;
}();

exports.Tx = Tx;